import { FormConfig } from "src/app/shared/models/dynamic.model";

export interface NoteModal {
  date_time: string;
  user: string;
  description: string;
  isFromScreen: '';
}

export const defaultNoteModal: NoteModal = {
  date_time: '',
  user: '',
  description: '',
  isFromScreen: '',
};

export interface NoteModalStateModel {
  noteModals: NoteModal[];
}

export const defaultNoteState: NoteModalStateModel = {
  noteModals: [],
};

export const noteAdvancedSearchFormFieldsConfig: FormConfig = {
  fields: [
    {
      id: 'date_time',
      type: 'input',
      label: 'Piece',
      maxValue: 126,
    },
    {
      type: 'input',
      maxValue: 126,
      label: 'Commodity',
      id: 'user',
    },
    {
      id: 'description',
      type: 'input',
      maxValue: 126,
      label: 'Bag',
    },
    {
      id: 'isFromScreen',
      maxValue: 126,
      type: 'input',
      label: 'Mawb',
    },
  ],
};
